var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LoadingButton } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { useState } from 'react';
import { FULFILLMENT_TYPE } from '../../../../constants/status';
import { FeatureSwitches } from '../../../../constants/feature-switches';
import { CmsCancelElibility, CmsCancellationReasonCodes, } from '../../../../hooks/cancel-items-hooks';
import '../../../../styles/order-details.scss';
import { isProductTypeEPPOnly } from '../../../../utils/hdppCheck-utils';
import { getOrderActionEligibility } from '../../util/FulfillmentStatus';
import { useOrderContext } from '../../../../hooks/useContexts';
export var RemorseCancel = function (_a) {
    var _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'primary' : _b, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, handleCancelEligibilityResult = _a.handleCancelEligibilityResult, isCancelEnabled = _a.isCancelEnabled, isLineItemCancelEnabled = _a.isLineItemCancelEnabled, orderDetailsData = _a.orderDetailsData, statusCode = _a.statusCode, customerType = _a.customerType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    var _c = useOrderContext(), setReasonCodesApiError = _c.setReasonCodesApiError, setCancellationReasonCodes = _c.setCancellationReasonCodes;
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useThdCustomer(), isLoggedIn = _e.isLoggedIn, isExchangeCustomer = _e.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var getEligibility = getOrderActionEligibility(fulfillmentType, statusCode);
    /* TODO: Refactor all the cancel functionality and DRY
     */
    var handleSTHorBOSSQtyCancel = function () {
        var isSingleItemWithQuantityOne = !(fulfillmentGroup.lineItems &&
            fulfillmentGroup.lineItems.length === 1 &&
            fulfillmentGroup.lineItems[0].currentQuantity === 1);
        setLoading(true);
        CmsCancelElibility(fulfillmentGroup, orderDetailsData, isSingleItemWithQuantityOne, true, false, handleCancelEligibilityResult, customerType, isAuthTHDUser, isLineItemCancelEnabled);
        setLoading(false);
    };
    var getCancelVariantAndOnClick = function (eligibility) {
        var variant = buttonVariant;
        var onClick;
        var cancelSTHorBOSSEligibilityCheck = eligibility === null || eligibility === void 0 ? void 0 : eligibility.isCancelEligibleForSTHorBOSS;
        if (cancelSTHorBOSSEligibilityCheck && isLineItemCancelEnabled) {
            onClick = function () { return handleSTHorBOSSQtyCancel(); }; // will navigate to Cancel Items page for Qty cancel
        }
        else if (cancelSTHorBOSSEligibilityCheck && !isLineItemCancelEnabled) {
            onClick = function () {
                setLoading(true);
                CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, true, false, handleCancelEligibilityResult, customerType, isAuthTHDUser, isLineItemCancelEnabled); // will open CancellationDrawer
                setLoading(false);
            };
        }
        else if (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isMAorBODFSorDFSCancelEligible) {
            onClick = function () {
                // MA Cancellation
                setLoading(true);
                if (fulfillmentType === FULFILLMENT_TYPE.MA &&
                    FeatureSwitches.enableMACancelReasonCodes) {
                    var _a = orderDetailsData || {}, emailId = _a.emailId, orderId = _a.orderNumber;
                    var reasonCodesRequest = {
                        orderId: orderId,
                        emailId: emailId,
                        fulfillmentType: 'MA',
                    };
                    CmsCancellationReasonCodes(reasonCodesRequest, isAuthTHDUser, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
                        .then(function (response) {
                        var _a, _b;
                        setCancellationReasonCodes(((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.cancellationReasonCodes) || []);
                        CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, false, false, handleCancelEligibilityResult, customerType, isAuthTHDUser);
                        setReasonCodesApiError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = false, _a)));
                        });
                    }) // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        .catch(function (_error) {
                        setReasonCodesApiError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a["".concat(fulfillmentGroupIndex)] = true, _a)));
                        });
                    });
                }
                else {
                    CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, false, false, handleCancelEligibilityResult, customerType, isAuthTHDUser);
                }
                setLoading(false);
            }; // will open CancellationDrawer
        }
        else if (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isBopisCancelEligible) {
            variant = (eligibility === null || eligibility === void 0 ? void 0 : eligibility.isBopisArrivedAndReadyForPickUp)
                ? 'secondary'
                : 'primary';
            onClick = function () {
                setLoading(true);
                CmsCancelElibility(fulfillmentGroup, orderDetailsData, false, false, false, handleCancelEligibilityResult, customerType, isAuthTHDUser);
                setLoading(false);
            }; // will open CancellationDrawer
        }
        else {
            return null;
        }
        return { variant: variant, onClick: onClick };
    };
    var result = getCancelVariantAndOnClick(getEligibility);
    /* check hdpps in the lineItems, within the single line item or multiple line items, if only single lineitem with hdpp do not render cancel button */
    var isHDPP = isProductTypeEPPOnly((fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || []);
    return (React.createElement(React.Fragment, null, isCancelEnabled && !isHDPP && result && (React.createElement("div", { className: "card-fix" },
        React.createElement(LoadingButton, { variant: result === null || result === void 0 ? void 0 : result.variant, onClick: result === null || result === void 0 ? void 0 : result.onClick, loading: loading, "data-testid": "test-cancel-items" }, "Cancel Items")))));
};
